

export const coreLocations =
{
	"thimphu_town": "Thimphu Town & Area",
	"outer_thimphu": "Outer Thimphu",
	"paro_town": "Paro Town & Area",
	"outer_paro": "Outer Paro",
	"phuentsholing_town": "Phuentsholing Town & Area",
	"outer_phuentsholing": "Outer Phuentsholing",
	"gelephu_town": "Gelephu Town & Area",
	"outer_gelephu": "Outer Gelephu",
	"punakha_town": "Punakha Town & Area",
	"outer_punakha": "Outer Punakha",
	"wangdue_town": "Wangdue Town & Area",
	"outer_wangdue": "Outer Wangdue",
	"bumthang_town": "Bumthang Town & Area",
	"outer_bumthang": "Outer Bumthang",
	"chukha_town": "Chukha Town & Area",
	"dagana_town": "Dagana Town & Area",
	"gasa_town": "Gasa Town & Area",
	"gantey_town": "Gantey Town & Area",
	"gomtu_town": "Gomtu Town & Area",
	"gyelposhing_town": "Gyelposhing Town & Area",
	"haa_town": "Haa Town & Area",
	"kanglung_town": "Kanlung Town & Area",
	"khaling_town": "Khaling Town & Area",
	"lobesa_town": "Lobesa Town & Area",
	"lhuentse_town": "Lhuentse Town & Area",
	"mongar_town": "Mongar Town & Area",
	"nanglam_town": "Nanglam Town & Area",
	"pemagatshel_town": "Pemagatshel Town & Area",
	"samdrupjongkhar_town": "Samdrupjongkhar Town & Area",
	"samtse_town": "Samtse Town & Area",
	"sarpang_town": "Sarpang Town & Area",
	"trongsa_town": "Trongsa Town & Area",
	"trashigang_town": "Trashigang Town & Area",
	"tsirang_town": "Tsirang Town & Area",
	"trashiyangtse_town": "Trashiyangtse Town & Area",
	"wamrong_town": "Wamrong Town & Area",
	"zhemgang_town": "Zhemgang Town & Area",
	"post_offices": "Deliver to Post Offices",
	"act_au": "ACT, Australia",
	"nsw_au": "NSW, Australia",
	"nt_au": "NT, Australia",
	"qld_au": "QLD, Australia",
	"sa_au": "SA, Australia",
	"tas_au": "TAS, Australia",
	"vic_au": "VIC, Australia",
	"wa_au": "WA, Australia"
};

export const dzongkhags =
{
	"Paro": [
		"Doga",
		"Dopshari",
		"Doteng",
		"Hungrel",
		"Lamgong",
		"Lungnyi",
		"Naja",
		"Shapa",
		"Tsento",
		"Wangchang"
	],
	"Thimphu": [
		"Chang",
		"Dagala",
		"Genyekha",
		"Kawang",
		"Lingzhi",
		"Mewang",
		"Naro",
		"Soe"
	],
	"Bumthang": [
		"Chhume",
		"Choekor",
		"Tang",
		"Ura"
	],
	"Chukha": [
		"Bjacho",
		"Bongo",
		"Chapcha",
		"Dala",
		"Dungna",
		"Geling",
		"Getena",
		"Logchina",
		"Metakha",
		"Phuentsholing",
		"Sampheling"
	],
	"Dagana": [
		"Dorona",
		"Drujegang",
		"Gesarling",
		"Goshi",
		"Kana",
		"Karmaling",
		"Khebisa",
		"Lajab",
		"Lhamoy Zingkha",
		"Nichula",
		"Tashiding",
		"Tsangkha",
		"Tsendagang",
		"Tseza"
	],
	"Gasa": [
		"Goenkhamae",
		"Goenkaatoe",
		"Laya",
		"Lunana"
	],
	"Punakha": [
		"Chhubu",
		"Dzomo",
		"Goenshari",
		"Guma",
		"Kabjisa",
		"Lingmukha",
		"Shenga Bjime",
		"Talog",
		"Toepisa",
		"Towang"
	],
	"Samtse": [
		"Dungtoe",
		"Dophoogchen",
		"Denchukha",
		"Namgaychhoeling",
		"Norbugang",
		"Norgaygang",
		"Pemaling",
		"Phuentshogpelri",
		"Samtse",
		"Sangngagchhoeling",
		"Tading",
		"Tashicholing",
		"Tendu",
		"Ugentse",
		"Yoeseltse"
	],
	"Tsirang": [
		"Barshong",
		"Dunglegang",
		"Goseling",
		"Kikhorthang",
		"Mendrelgang",
		"Patshaling",
		"Phutenchhu",
		"Rangthangling",
		"Semjong",
		"Sergithang",
		"Tsholingkhar",
		"Tsirangtoe"
	],
	"Wangdue Phodrang": [
		"Athang",
		"Bjena",
		"Daga",
		"Dangchu",
		"Gangte",
		"Gasetsho Gom",
		"Gasetsho Om",
		"Kazhi",
		"Nahi",
		"Nyisho",
		"Phangyuel",
		"Phobji",
		"Ruepisa",
		"Sephu",
		"Thedtsho"
	],
	"Sarpang": [
		"Chhuzagang",
		"Chhudzom",
		"Dekiling",
		"Gakiling",
		"Gelephu",
		"Jigmechhoeling",
		"Samtenling",
		"Senghe",
		"Serzhong",
		"Shompangkha",
		"Tareythang",
		"Umling"
	],
	"Trongsa": [
		"Dragteng",
		"Korphu",
		"Langthil",
		"Nubi",
		"Tangsibji"
	],
	"Zhemgang": [
		"Bardho",
		"Bjoka",
		"Goshing",
		"Nangkor",
		"Ngangla",
		"Phangkhar",
		"Shingkhar",
		"Trong"
	],
	"Haa": [
		"Bji",
		"Gakiling",
		"Katsho",
		"Sama",
		"Sangbay",
		"Uesu"
	],
	"Lhuntse": [
		"Gangzur",
		"Jaray",
		"Khoma",
		"Kurtoe",
		"Menbi",
		"Metsho",
		"Minjay",
		"Tsenkhar"
	],
	"Mongar": [
		"Balam",
		"Chaskhar",
		"Chhali",
		"Drametse",
		"Drepung",
		"Gongdue",
		"Jurmey",
		"Kengkhar",
		"Mongar",
		"Narang",
		"Ngatshang",
		"Saleng",
		"Sherimung",
		"Silambi",
		"Thangrong",
		"Tsakaling",
		"Tsamang"
	],
	"Pemagatshel": [
		"Chhimung",
		"Choekhorling",
		"Chongshing Borang",
		"Dechenling",
		"Dungme",
		"Khar",
		"Nanong",
		"Norbugang",
		"Shumar",
		"Yurung",
		"Zobel"
	],
	"Samdrup Jongkhar": [
		"Dewathang",
		"Gomdar",
		"Langchenphu",
		"Lauri",
		"Martshala",
		"Orong",
		"Pemathang",
		"Phuntshothang",
		"Samrang",
		"Serthi",
		"Wangphu"
	],
	"Trashigang": [
		"Bartsham",
		"Bidung",
		"Kanglung",
		"Kangpara",
		"Khaling",
		"Lumang",
		"Merak",
		"Phongmey",
		"Radhi",
		"Sakteng",
		"Samkhar",
		"Shongphu",
		"Thrimshing",
		"Uzorong",
		"Yangneer"
	],
	"Trashiyangtse": [
		"Bumdeling",
		"Jamkhar",
		"Khamdang",
		"Ramjar",
		"Toetsho",
		"Tomzhangsa",
		"Trashiyangtse",
		"Yalang"
	]
};

export const postOfficeLocations =
{
	"thimphu_post_office": "Thimphu Post Office",
	"thimphudzong_post_office": "Thimphu Dzong Post Office",
	"paro_post_office": "Paro Post Office",
	"paro_airport_post_office": "Paro Airport Post Office",
	"phuentsholing_post_office": "Phuentsholing Post Office",
	"gelephu_post_office": "Gelephu Post Office",
	"punakha_post_office": "Punakha Post Office",
	"wangdue_post_office": "Wangdue Post Office",
	"bumthang_post_office": "Bumthang Post Office",
	"tshimasham_post_office": "Tshimasham Post Office",
	"gedu_post_office": "Gedu Post Office",
	"dagana_post_office": "Dagana Post Office",
	"lhamozingkha_post_office": "Lhamozingkha Post Office",
	"dagapela_post_office": "Dagapela Post Office",
	"gasa_post_office": "Gasa Post Office",
	"haa_post_office": "Haa Post Office",
	"kanglung_post_office": "Kanglung Post Office",
	"khaling_post_office": "Khaling Post Office",
	"lhuentse_post_office": "Lhuentse Post Office",
	"mongar_post_office": "Mongar Post Office",
	"gyelposhing_post_office": "Gyelposhing Post Office",
	"nganglam_post_office": "Nganglam Post Office",
	"pemagatshel_post_office": "Pemagatshel Post Office",
	"samdrupjongkhar_post_office": "Samdrupjongkhar Post Office",
	"Jomotsangkha_post_office": "Jomotsangkha Post Office",
	"samdrupcholing_post_office": "Samdrupcholing Post Office",
	"samtse_post_office": "Samtse Post Office",
	"sipsoo_post_office": "Sipsoo Post Office",
	"gomtu_post_office": "Gomtu Post Office",
	"sarpang_post_office": "Sarpang Post Office",
	"trongsa_post_office": "Trongsa Post Office",
	"trashigang_post_office": "Trashigang Post Office",
	"rangjung_post_office": "Rangjung Post Office",
	"tsirang_post_office": "Tsirang Post Office",
	"trashiyangtse_post_office": "Trashiyangtse Post Office",
	"doksum_post_office": "Doksum Post Office",
	"wamrong_post_office": "Wamrong Post Office",
	"zhemgang_post_office": "Zhemgang Post Office",
	"panbang_post_office": "Panbang Post Office",
};

export const coreLocationsWithPO =
{
	"thimphu_town": "Thimphu Town & Area",
	"outer_thimphu": "Outer Thimphu",
	"thimphu_post_office": "Thimphu Post Office",
	"paro_town": "Paro Town & Area",
	"outer_paro": "Outer Paro",
	"paro_post_office": "Paro Post Office",
	"paro_airport_post_office": "Paro Airport Post Office",
	"phuentsholing_town": "Phuentsholing Town & Area",
	"outer_phuentsholing": "Outer Phuentsholing",
	"phuentsholing_post_office": "Phuentsholing Post Office",
	"gelephu_town": "Gelephu Town & Area",
	"outer_gelephu": "Outer Gelephu",
	"gelephu_post_office": "Gelephu Post Office",
	"punakha_town": "Punakha Town & Area",
	"outer_punakha": "Outer Punakha",
	"punakha_post_office": "Punakha Post Office",
	"wangdue_town": "Wangdue Town & Area",
	"outer_wangdue": "Outer Wangdue",
	"wangdue_post_office": "Wangdue Post Office",
	"bumthang_town": "Bumthang Town & Area",
	"outer_bumthang": "Outer Bumthang",
	"bumthang_post_office": "Bumthang Post Office",
	"chukha_town": "Chukha Town & Area",
	"tshimasham_post_office": "Tshimasham Post Office",
	"gedu_post_office": "Gedu Post Office",
	"dagana_town": "Dagana Town & Area",
	"dagana_post_office": "Dagana Post Office",
	"lhamozingkha_post_office": "Lhamozingkha Post Office",
	"dagapela_post_office": "Dagapela Post Office",
	"gasa_town": "Gasa Town & Area",
	"gasa_post_office": "Gasa Post Office",
	"gantey_town": "Gantey Town & Area",
	"gomtu_town": "Gomtu Town & Area",
	"gyelposhing_town": "Gyelposhing Town & Area",
	"haa_town": "Haa Town & Area",
	"haa_post_office": "Haa Post Office",
	"kanglung_town": "Kanlung Town & Area",
	"kanglung_post_office": "Kanglung Post Office",
	"khaling_town": "Khaling Town & Area",
	"khaling_post_office": "Khaling Post Office",
	"lobesa_town": "Lobesa Town & Area",
	"lhuentse_town": "Lhuentse Town & Area",
	"lhuentse_post_office": "Lhuentse Post Office",
	"mongar_town": "Mongar Town & Area",
	"mongar_post_office": "Mongar Post Office",
	"gyelposhing_post_office": "Gyelposhing Post Office",
	"nganglam_town": "Nganglam Town & Area",
	"nganglam_post_office": "Nganglam Post Office",
	"pemagatshel_town": "Pemagatshel Town & Area",
	"pemagatshel_post_office": "Pemagatshel Post Office",
	"samdrupjongkhar_town": "Samdrupjongkhar Town & Area",
	"samdrupjongkhar_post_office": "Samdrupjongkhar Post Office",
	"Jomotsangkha_post_office": "Jomotsangkha Post Office",
	"samdrupcholing_post_office": "Samdrupcholing Post Office",
	"samtse_town": "Samtse Town & Area",
	"samtse_post_office": "Samtse Post Office",
	"sipsoo_post_office": "Sipsoo Post Office",
	"gomtu_post_office": "Gomtu Post Office",
	"sarpang_town": "Sarpang Town & Area",
	"sarpang_post_office": "Sarpang Post Office",
	"trongsa_town": "Trongsa Town & Area",
	"trongsa_post_office": "Trongsa Post Office",
	"trashigang_town": "Trashigang Town & Area",
	"trashigang_post_office": "Trashigang Post Office",
	"rangjung_post_office": "Rangjung Post Office",
	"tsirang_town": "Tsirang Town & Area",
	"tsirang_post_office": "Tsirang Post Office",
	"trashiyangtse_town": "Trashiyangtse Town & Area",
	"trashiyangtse_post_office": "Trashiyangtse Post Office",
	"doksum_post_office": "Doksum Post Office",
	"wamrong_town": "Wamrong Town & Area",
	"wamrong_post_office": "Wamrong Post Office",
	"zhemgang_town": "Zhemgang Town & Area",
	"zhemgang_post_office": "Zhemgang Post Office",
	"panbang_post_office": "Panbang Post Office",
	"thimphudzong_post_office": "Thimphu Dzong Post Office",
};

